import { render, staticRenderFns } from "./BatchRestoreContainer.vue?vue&type=template&id=45cbc5bf"
import script from "./BatchRestoreContainer.vue?vue&type=script&lang=js"
export * from "./BatchRestoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports